import React, { FC, useState } from 'react';

import { EvComboboxOption, EvSelectNew } from '@evinced-private/ui-common';

import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';
import { IScopeRuleRowProps } from '../scope-rules-list/ScopeRulesList.types';

import {
	ACTION_LABEL,
	ACTION_PLACEHOLDER,
	ISSUE_SEVERITIES_ACTIONS,
	REMOVE_ISSUE_BUTTON_TITLE,
	SEVERITY_VALUE_LABEL,
	SEVERITY_VALUE_PLACEHOLDER
} from './IssueSeveritiesRuleRow.constants';
import { ScopeRuleRow } from './ScopeRuleRow';

export const IssueSeveritiesRuleRow: FC<IScopeRuleRowProps> = ({
	rule,
	issueSeveritiesList,
	onRemove,
	onRuleChange
}) => {
	const [selectedAction, setSelectedAction] = useState<EvComboboxOption>(
		ISSUE_SEVERITIES_ACTIONS.find((action) => action.value === rule?.scopeAction)
	);

	const [selectedIssueSeverities, setSelectedIssueSeverities] = useState<EvComboboxOption[]>(() => {
		if (rule?.issueSeverities?.length) {
			return rule.issueSeverities.map((severity: string) => ({ label: severity, value: severity }));
		}

		return [];
	});

	return (
		<ScopeRuleRow
			removeButtonTitle={REMOVE_ISSUE_BUTTON_TITLE}
			onRemove={onRemove}
			actionControl={
				<EvSelectNew
					id="issue-severity-rule-select"
					options={ISSUE_SEVERITIES_ACTIONS}
					selectedValue={[selectedAction]}
					onSelectChange={(selected) => {
						setSelectedAction(selected[0]);
						onRuleChange?.({ ...rule, scopeAction: selected[0].value as SCOPE_ACTIONS });
					}}
					placeholder={ACTION_PLACEHOLDER}
					label={ACTION_LABEL}
				/>
			}
			valueControl={
				<EvSelectNew
					id="issue-severity-select-list"
					options={issueSeveritiesList}
					selectedValue={selectedIssueSeverities}
					onSelectChange={(selected) => {
						setSelectedIssueSeverities(selected);
						onRuleChange?.({
							...rule,
							issueSeverities: selected.map((issue) => String(issue.value))
						});
					}}
					placeholder={SEVERITY_VALUE_PLACEHOLDER}
					label={SEVERITY_VALUE_LABEL}
					isMultiple
				/>
			}
		/>
	);
};
